// @flow
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

import type { Role } from 'state/types';
import { updateRole } from 'state/commands/roleCommands';
import localizedStrings from 'util/localizedStrings';
import {
  allPermissions,
  settableForReader,
  unsettableForEditor,
  unsettableForPublisher,
} from 'util/permissionUtils';
import {
  NAME_ADMIN,
  NAME_EDITOR,
  NAME_PUBLISHER,
  NAME_READER,
} from 'util/roleUtils';

type Props = {
  role: Role,
  intl: IntlShape,
  updateRole: typeof updateRole,
};

class RoleDetailsPage extends Component<Props> {
  isDisabled: Function;
  onChange: Function;

  constructor() {
    super();
    this.isDisabled = this.isDisabled.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  isDisabled(perm, role) {
    switch (role && role.name) {
      case NAME_ADMIN:
        return true;
      case NAME_PUBLISHER:
        return unsettableForPublisher.includes(perm);
      case NAME_EDITOR:
        return unsettableForEditor.includes(perm);
      case NAME_READER:
        return !settableForReader.includes(perm);
      default:
        return false;
    }
  }

  onChange(event, name) {
    const { role, updateRole } = this.props;
    const checked = event.target.checked;
    const grant = checked ? name : '';
    const revoke = checked ? '' : name;
    updateRole(role.name, grant, revoke);
  }

  render() {
    const {
      role,
      intl: { formatMessage },
    } = this.props;

    return (
      <div className="page">
        <header className="page-header">
          <FormattedMessage {...localizedStrings.ROLES_PERMISSIONS} />
        </header>
        <div
          className="portfolio-form-container is-textured"
          data-test-name="role-permission-list"
        >
          <div className="box">
            {allPermissions
              .sort((a, b) =>
                formatMessage(localizedStrings[a]).localeCompare(
                  formatMessage(localizedStrings[b])
                )
              )
              .map(perm => {
                return (
                  <div className="field" key={perm}>
                    <input
                      checked={role.permissions.includes(perm)}
                      className="is-checkradio"
                      disabled={this.isDisabled(perm, role)}
                      id={perm}
                      onChange={e => this.onChange(e, perm)}
                      type="checkbox"
                      data-test-name={'permission-' + perm}
                    />
                    <label className="role-label" htmlFor={perm}>
                      {formatMessage(localizedStrings[perm])}
                    </label>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(RoleDetailsPage);



// WEBPACK FOOTER //
// ./src/view/Pages/RolesPage/RoleDetailsForm.js